// src/api/modulesApi.js
import axios from "axios";

export const updateModule = async (id, updatedData) => {
  try {
    const response = await axios.put(`http://localhost:8080/webnet-hms/api/modules/${id}`, updatedData);
    console.log(response.data);
  } catch (error) {
    window.alert("Error updating module:", error);
    throw error;
  }
};
